export default __webpack_public_path__ + "798ce053780d9370196593c00cded959.png";